import axios from "axios";

let headers = {};
headers["accept"] = "*/*";
headers["Accept-Language"] = "en";
headers["Content-Type"] = "application/json";

const instance = axios.create({
  baseURL: "https://api.foodflowcompany.ie/api/v1",
  headers,
});

export default instance;